<template>
	<div class="v-datepicker">
		<template v-if="!inline">
			<input v-model="displayDate" :disabled="disabled" type="text" @focus="show()">
			<input v-model="date" :disabled="disabled" type="hidden" @focus="show()" v-on:datesChanged="changed">
			<button v-if="clearable" class="v-datepicker__clear" @click.prevent="clear()">Clear</button>
		</template>
		<template v-else>
			<v-date-picker
				ref="calendar"
				:field-label="fieldLabel"
				:max-date="maxDate"
				:min-date="minDate"
				:minute-increment="minuteIncrement"
				:mode="mode"
				:model-config="datePickerConfig"
				:value="date"
				is-expanded
				is-inline
				title-position="left"
				v-bind="attrs"
				@input="changed()"
				@update:to-page="(page) => pageChanged(page)"/>
		</template>
	</div>
</template>
<script>
import moment from "moment";

export default {
	data() {
		return {
			displayDate: null,
			datePickerConfig: {
				start: {
					timeAdjust: this.startTimeAdjust,
				},
				end: {
					timeAdjust: this.endTimeAdjust,
				},
			},
			modalParams: {
				component: require("./v-datepicker-calendar.vue").default,
				props: {
					fieldLabel: this.fieldLabel,
					input: this,
					minDate: this.minDate,
					maxDate: this.maxDate,
					mode: this.mode,
				},
			},
		};
	},

	props: {
		fieldLabel: {
			type: String,
			required: false,
			default() {
				return null;
			},
		},
		startTimeAdjust: {
			type: String,
			default() {
				return "00:00:00";
			},
		},
		endTimeAdjust: {
			type: String,
			default() {
				return "23:59:59";
			},
		},
		disabled: {
			type: Boolean,
			default() {
				return false;
			},
		},
		mode: {
			type: String,
			default() {
				return "date";
			},
		},
		formatDates: {
			type: Boolean,
			default() {
				return true;
			},
		},
		dateFormat: {
			type: String,
			required: false,
			default() {
				return "YYYY-MM-DD";
			},
		},
		dateDisplayFormat: {
			type: String,
			required: false,
			default() {
				return "YYYY-MM-DD";
			},
		},
		minuteIncrement: {
			required: false,
			type: Number,
			default() {
				return 5;
			},
		},
		minDate: {
			require: false,
		},
		maxDate: {
			require: false,
		},
		clearable: {
			type: Boolean,
			default() {
				return true;
			},
		},
		inline: {
			type: Boolean,
			default() {
				return false;
			},
		},
		range: {
			type: Boolean,
			default() {
				return false;
			},
		},
		_24hr: {
			type: Boolean,
			default() {
				return true;
			},
		},
		modelConfig: {
			type: Object,
			default() {
				return {};
			},
		},
	},

	computed: {
		attrs() {
			return {
				isRange: this.range,
				is24hr: this._24hr,
			};
		},
		date: {
			get() {
				return this.$attrs.value;
			},
			set(date) {
				this.value = date;
				this.$emit("input", this.value);
				this.$emit("changed", this.value);
			},
		},
	},

	methods: {
		show() {
			if (this.disabled) {
				return;
			}
			this.$vmodal.replace(this.modalParams);
		},
		pageChanged(page) {
			this.$emit("pageChanged", page);
		},
		getDateFormat(display = false) {
			let dateFormat = !display ? this.dateFormat : this.dateDisplayFormat;
			let modeFormats = {
				date: dateFormat,
				dateTime: dateFormat + " HH:mm:ss",
				time: "HH:mm:ss",
			};

			return modeFormats[this.mode];
		},
		changed(date) {
			let value = !this.range
				? moment(date)
				: {
					start: moment(date.start),
					end: moment(date.end),
				};

			this.setDates(value);
			this.setDates(value, true);

			// if (!this.inline) {
			// 	this.$vmodal.back();
			// }
		},
		setDates(value, display = false) {
			if (!this.formatDates) {
				this.date = value;
				return;
			}

			value = !this.range
				? value.format(this.getDateFormat(display))
				: _.mapValues(value, function (date) {
					return date.format(this.getDateFormat(display));
				}.bind(this));

			if (!display) {
				this.date = value;
				return;
			}

			this.displayDate = value;
		},
		setDisplayDates(date) {
			if (this.range) {
				let dates = {
					start: moment(date.start),
					end: moment(date.end),
				};

				if (this.dateDisplayFormat) {
					dates = _.mapValues(dates, function (date) {
						return date.format(this.getDateFormat(true));
					}.bind(this));
				}

				this.date = dates;
			} else {
				let newDate = moment(date);

				this.displayDate = this.date.format();
			}
		},
		clear() {
			if (!this.clearable) {
				return;
			}

			this.date = "";
			this.displayDate = "";
		},
	},

	created() {
		if (!this.date) {
			return;
		}
		this.setDates(moment(new Date(this.date)), true);
	},
};
</script>
